import { get } from "lodash";

export const getUserAccount = () => JSON.parse(localStorage.userAccount);

export const setUserAccount = (result) => {
  const userAccount = {};
  console.log("User IP: ", get(
    result.result,
    "userIp[0]",
    ""
  ));
  userAccount.acctFirstName = get(
    result.result,
    "data[0].userdata[0].acctFirstName[0]",
    ""
  );
  userAccount.acctLastName = get(
    result.result,
    "data[0].userdata[0].acctLastName[0]",
    ""
  );
  userAccount.mastType = get(
    result.result,
    "data[0].userdata[0].mastType[0]",
    ""
  );
  userAccount.mastState = get(
    result.result,
    "data[0].userdata[0].mastState[0]",
    ""
  );
  userAccount.btType = get(result.result, "data[0].userdata[0].btType[0]", "");
  userAccount.restrictLN = get(
    result.result,
    "data[0].userdata[0].mastRestrictLN[0]",
    ""
  );
  userAccount.acctActive = get(
    result.result,
    "data[0].userdata[0].acctActive[0]",
    ""
  );
  userAccount.acctPickUser = get(
    result.result,
    "data[0].userdata[0].acctPickUser[0]",
    ""
  );
  userAccount.acctMasterUser = get(
    result.result,
    "data[0].userdata[0].acctMasterUser[0]",
    ""
  );
  userAccount.mastSSNMask = get(
    result.result,
    "data[0].userdata[0].mastSSNMask[0]",
    ""
  );
  userAccount.mastDOBMask = get(
    result.result,
    "data[0].userdata[0].mastDOBMask[0]",
    ""
  );
  userAccount.acctTheme = parseInt(
    get(result.result, "data[0].userdata[0].acctTheme[0]", "0"),
    10
  );
  userAccount.mastSearchBySSN = parseInt(
    get(result.result, "data[0].userdata[0].mastSearchBySSN[0]", "0"),
    10
  );
  userAccount.lastLogin = get(
    result.result,
    "data[0].userdata[0].lastLogin[0]",
    ""
  );
  const flatRate = get(
    result.result,
    "data[0].userdata[0].typeFlatRate[0]",
    ""
  );
  if (flatRate === "1" || flatRate.toLowerCase() === "true") {
    userAccount.flatRate = true;
  } else {
    userAccount.flatRate = false;
  }
  localStorage.userAccount = JSON.stringify(userAccount);
};

export default getUserAccount;



// WEBPACK FOOTER //
// ./src/metadata/userAccount.js